import { useState } from 'react';
import ArticleCard from '@/components/base/ArticleCard';
import { getLatestArticles, articles } from '@/mocks/articles';
import type { Article } from '@/mocks/articles';

export default function NewsGrid() {
  const [visibleCount, setVisibleCount] = useState(8);
  const allLatest = getLatestArticles(articles.length);

  const displayed = allLatest.slice(0, visibleCount);
  const hasMore = visibleCount < allLatest.length;

  return (
    <section className="bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">最新爆料</h2>
          </div>
          <span className="text-xs text-foreground-500 bg-background-50 px-3 py-1.5 rounded-full border border-secondary-200/70 whitespace-nowrap">
            共 {allLatest.length} 篇
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayed.map((article: Article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        {hasMore && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setVisibleCount((prev) => Math.min(prev + 8, allLatest.length))}
              className="px-8 py-3 rounded-full border-2 border-secondary-300 text-sm font-medium text-foreground-700 hover:border-primary-500 hover:text-primary-600 transition-all duration-200 bg-background-50 cursor-pointer whitespace-nowrap"
            >
              加载更多
              <i className="ri-arrow-down-s-line ml-1 w-4 h-4 inline-flex items-center justify-center"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}